module.exports = __webpack_public_path__ + "img/LR-hauptseite_kachel_LOESUNGENFUERJEDELEBENSLAGE.ecf89bc7.png";